import { useEffect } from 'react'
import { useApp } from '@src/AppContext'
import { Access } from '@src/services/Helper'
import { useSettings } from '../Context'
import EditorSection from './EditorSection'

// Where the wording comes from / where a save goes (consent_templates is
// holding-scoped: the company's own version, else the platform default).
function scopeNote(meta) {
  if (!meta) return null
  if (meta.scope === 'platform') {
    return 'Platform default — used by every company that has not saved its own wording.'
  }
  return meta.isDefault
    ? 'Using the Everest default wording. Saving creates your company\'s own version.'
    : null
}

export default function ConsentEditor() {
  const { hasPermission } = useApp()
  const {
    candidateContent,
    setCandidateContent,
    existingContent,
    setExistingContent,
    isLoadingConsent,
    isSavingConsent,
    consentScope,
    fetchConsentEditor,
    updateConsentEditor,
    cancelConsentEditor,
  } = useSettings()

  const canEdit = hasPermission(Access.CONSENT_EDITOR, 'edit')

  useEffect(() => {
    if (canEdit) fetchConsentEditor()
  }, [canEdit, fetchConsentEditor])

  if (isLoadingConsent) {
    return (
      <div className="flex items-center justify-center pt-16">
        <span className="text-sm text-[#535862]">Loading...</span>
      </div>
    )
  }

  return (
    <div className="flex flex-col overflow-y-auto [&::-webkit-scrollbar]:hidden">
      <EditorSection
        title="Candidate"
        content={candidateContent}
        onUpdate={setCandidateContent}
        onSave={() => updateConsentEditor('candidate')}
        onCancel={() => cancelConsentEditor('candidate')}
        isSaving={isSavingConsent.candidate}
        canEdit={canEdit}
        note={scopeNote(consentScope.candidate)}
      />
      <EditorSection
        title="Existing"
        content={existingContent}
        onUpdate={setExistingContent}
        onSave={() => updateConsentEditor('existing')}
        onCancel={() => cancelConsentEditor('existing')}
        isSaving={isSavingConsent.existing}
        canEdit={canEdit}
        note={scopeNote(consentScope.existing)}
      />
    </div>
  )
}
